import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Calendar } from 'react-modern-calendar-datepicker';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import USERS from '../../common/data/userDummyData';
import Avatar from '../../components/Avatar';
import Button, { ButtonGroup } from '../../components/bootstrap/Button';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../layout/SubHeader/SubHeader';
import useOnClickMode from '../../hooks/OnClickMode';
import Search from '../../components/bootstrap/Search';
import Page from '../../layout/Page/Page';
import Card, { CardBody } from '../../components/bootstrap/Card';
import useSortableData from '../../hooks/useSortableData';
import PaginationButtons, { dataPagination, PER_COUNT } from '../../components/PaginationButtons';
import Dropdown, {
	DropdownToggle,
	DropdownItem,
	DropdownMenu,
} from '../../components/bootstrap/Dropdown';
import Icon from '../../components/icon/Icon';
import Badge from '../../components/bootstrap/Badge';
import InfluencerProfile from '../../components/custom/ContentManagementComponents/InfluencerCard';
import Checks from '../../components/bootstrap/forms/Checks';
import Carousel from '../../components/bootstrap/Carousel';
import COLORS from '../../common/data/enumColors';
import CalendarPage, {
	NotesPage,
} from '../../components/custom/ContentManagementComponents/CalendarPage';
// import Page from '../../layout/Page/Page';
// import Popovers from '../../components/bootstrap/Popovers';
import ContentLibrary from '../../components/custom/DashboardComponents/ContentLibrary';
import Item from '../../components/custom/DiscoveryComponents/SearchResultCards';

// import { useCampaignQuery } from '../../framework/basic-rest/campaign/get-campaign';

export const _dropdownInner = (
	<>
		<DropdownItem isHeader>Header</DropdownItem>
		<DropdownItem>
			<NavLink to='/components/popovers'>
				<Icon icon='Send' /> Navlink
			</NavLink>
		</DropdownItem>
		<DropdownItem isDivider />
		<DropdownItem isText>Lorem ipsum dolor sit amet.</DropdownItem>
		<DropdownItem>
			<a href='/'>
				<div className='col text-nowrap overflow-hidden text-overflow-ellipsis'>
					<Icon icon='Send' /> Link Item
				</div>
				<div className='col-auto'>
					<Badge>2</Badge>
				</div>
			</a>
		</DropdownItem>
		<DropdownItem>String</DropdownItem>
	</>
);

const ContentManagementPage = () => {
	const CATEGORIES = {
		DOCUMENTATION: {
			value: 'documentation',
			text: 'Documentation',
		},
		SETTINGS: {
			value: 'settings',
			text: 'Settings',
		},
		COLORS: {
			value: 'colors',
			text: 'Colors',
		},
	};
	const TAGS = {
		NPM: {
			text: 'NPM',
			color: COLORS.SUCCESS.name,
		},
		YARN: {
			text: 'Yarn',
			color: COLORS.DANGER.name,
		},
		BOOTSTRAP: {
			text: 'Bootstrap',
			color: COLORS.PRIMARY.name,
		},
		DEPENDENCIES: {
			text: 'Dependencies',
			color: COLORS.INFO.name,
		},
	};
	const item = {
		id: 1,
		title: 'Rohit Chauhan',
		description: 'The utility API is a Sass-based tool to generate utility classes.',
		// image: Img4,
		User: USERS.JANE,
		AvatarSize: 90,
		tags: [TAGS.NPM, TAGS.YARN, TAGS.BOOTSTRAP],
		color: COLORS.WARNING.name,
		categories: [CATEGORIES.DOCUMENTATION, CATEGORIES.SETTINGS],
		content:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer facilisis faucibus interdum. Donec dapibus fringilla elementum. Pellentesque et quam quis mauris suscipit laoreet. Integer a eleifend magna. Quisque iaculis massa sit amet molestie eleifend. Nunc id finibus massa, vel eleifend turpis. Maecenas interdum neque non neque porta venenatis. Duis nec viverra nisi. Aenean enim nulla, egestas at congue et, vehicula eget sem. Donec molestie bibendum fermentum. Sed tempor, augue sit amet scelerisque vehicula, lacus nunc eleifend tellus, at lobortis felis erat eu dui. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas libero mi, lacinia a purus sagittis, aliquam fringilla magna. Mauris commodo mollis iaculis. Cras metus mauris, tincidunt ac dapibus in, facilisis vel ipsum.',
	};
	// const {
	// 	isFetching: isLoading,
	// 	isFetchingNextPage: loadingMore,
	// 	fetchNextPage,
	// 	hasNextPage,
	// 	data,
	// 	error,
	//   } = useCampaignQuery({ ...query });
	const TABS = {
		INFLUENCERS: 'Influencers',
		CONTENT: 'Content',
		CALENDER: 'Calender',
		APPROVALS: 'Approvals',
	};
	const { themeStatus, onClickStatus } = useOnClickMode();
	const [activeTab, setActiveTab] = useState(TABS.INFLUENCERS);
	const [tableData, setTableData] = useState([]);
	const data = [
		{
			name: 'James Bond',
			relationship_status: 'outreach',
			content_status: 'Content Approved',
			tags: 'List-1',
			social_media: 'ER:2% Followers:34K',
			campaign_status: 'Live',
			budget: '20K',
			options: tableData.options,
			content_type: 'Reels',
		},
		{
			name: 'Ethan Hunt',
			relationship_status: 'outreach',
			content_status: 'Content Approved',
			tags: 'List-2',
			social_media: 'ER:2% Followers:34K',
			campaign_status: 'Live',
			budget: '20K',
			options: tableData.options,
			content_type: 'Post',
		},
		{
			name: 'Kill Bill',
			relationship_status: 'outreach',
			content_status: 'Content Approved',
			tags: 'List-3',
			social_media: 'ER:2% Followers:34K',
			campaign_status: 'Live',
			budget: '20K',
			options: tableData.options,
			content_type: 'IGTV',
		},
	];
	const influencerData = [
		{
			id: 1,
			name: 'James Bond',
			description: 'The Name is Bond James Bond',
			tags: [
				{
					text: 'Label 1',
					color: 'danger',
				},
				{
					text: 'Label 2',
					color: 'light',
				},
				{
					text: 'Label 3',
					color: 'success',
				},
			],
			contentType: 'Health & Life Style',
			status: 'active',
			influencerContent: [
				{
					src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa1d%20text%20%7B%20fill%3A%23555%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa1d%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22285.921875%22%20y%3D%22218.3%22%3EFirst%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
					altText: 'Influencer Post 1',
					captionHeader: 'Approved',
				},
				{
					src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa20%20text%20%7B%20fill%3A%23444%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa20%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23666%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22247.3203125%22%20y%3D%22218.3%22%3ESecond%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
					altText: 'Influencer Post 2',
					captionHeader: 'Approved',
				},
				{
					src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa21%20text%20%7B%20fill%3A%23333%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa21%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23555%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22277%22%20y%3D%22218.3%22%3EThird%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
					altText: 'Influencer Post 3',
					captionHeader: 'Rejected',
				},
			],
		},
	];
	useEffect(() => {
		if (activeTab === TABS.INFLUENCERS) {
			setTableData(data);
		}
		return () => { };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeTab]);
	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(PER_COUNT['3']);
	const { items } = useSortableData(tableData);

	return (
		<PageWrapper title='Content Management Page' className='content_management_wrapper'>
			<br />
			<SubHeader container='fluid'>
				<SubHeaderLeft>
					<span className='h4 mb-0 fw-bold'>Content Management</span>
				</SubHeaderLeft>
				<SubHeaderRight>
					<div style={{ textAlign: 'right' }}>
						<Button color={onClickStatus ? 'light' : 'danger'} isLight icon='Share'>
							Share
						</Button>
					</div>
				</SubHeaderRight>
			</SubHeader>
			<Page container='fluid'>
				<SubHeader>
					<div className='row'>
						<div className='col'>
							<ButtonGroup>
								{Object.keys(TABS).map((key) => (
									<Button
										key={key}
										color={activeTab === TABS[key] ? 'danger' : themeStatus}
										onClick={() => setActiveTab(TABS[key])}
										isVertical='true'>
										{TABS[key]}
									</Button>
								))}
							</ButtonGroup>
						</div>
					</div>
				</SubHeader>
				<div className='row'>
					<div className='col'>
						<Card>
							<CardBody>
								<table className='table table-modern'>
									<thead>
										<tr>
											<th> </th>
											<th>NAME</th>
											<th>STATUS</th>
											<th>CONTENT TYPE</th>
											<th>TAGS</th>
										</tr>
									</thead>
									<tbody>
										{activeTab === TABS.INFLUENCERS &&
											dataPagination(items, currentPage, perPage).map(
												(val) => {
													const { key } = val;
													return (
														<tr key={key}>
															<td>
																<Checks
																	type='checkbox'
																	checked={onclick}
																/>
															</td>
															<td>{val.name}</td>
															<td>{val.content_status}</td>
															<td>{val.content_type}</td>
															<td>{val.tags}</td>
														</tr>
													);
												},
											)}
									</tbody>
								</table>
							</CardBody>
							<PaginationButtons
								data={items}
								label='items'
								setCurrentPage={setCurrentPage}
								currentPage={currentPage}
								perPage={perPage}
								setPerPage={setPerPage}
							/>
						</Card>
					</div>
				</div>
				<SubHeader>
					<Dropdown>
						<DropdownToggle>
							<Button color='success' isLight>
								Influencer List
							</Button>
						</DropdownToggle>
						<DropdownMenu>
							{data.map((val) => (
								<DropdownItem>
									<div className='row' style={{ width: '100%' }}>
										<Checks label={val.name} checked={onclick} />
									</div>
								</DropdownItem>
							))}
						</DropdownMenu>
					</Dropdown>
				</SubHeader>
				<br />
				{influencerData.map((influencer) => (
					<div className='row'>
						<div className='col-md-3'>
							<Item {...item} />
							
							{/* <InfluencerProfile {...influencer} /> */}
						</div>

						{/* <div className='col-md-3'>
							<Carousel
								items={influencer.influencerContent}
								rounded={1}
								activeItemIndex={1}
								isRide={false}
							/>
						</div> */}
						<div className='col-md-3'>
							<CalendarPage />
						</div>
						<div className='col-xxl-3'>
							{/* <NotesPage /> */}
							<Card className='card_content_library'>
								<CardBody isScrollable>
									<ContentLibrary imageClass='col-xxl-4 col-lg-4 col-md-12' />
									{/* darkModeStatus={darkModeStatus}  */}
								</CardBody>
							</Card>
						</div>
					</div>
				))}
			</Page>
		</PageWrapper>
	);
};

export default ContentManagementPage;
